<div class="bnf" dir="rtl">
  <header class="bnf__header">
    <span class="bnf__eyebrow">אזור אישי</span>
    <h1 class="bnf__h1">ההטבות שלי</h1>
    <p class="bnf__lead">קופונים שהפעלת ומכסת המודעות שהם מעניקים לפרסום ללא עלות.</p>
  </header>

  <app-coupon-activation [autoLoad]="false" [showBenefitsLink]="false"></app-coupon-activation>

  @if (pending.length) {
    <section class="bnf-pending" aria-labelledby="bnf-pending-title">
      <h2 id="bnf-pending-title" class="bnf__h2">קודים שממתינים להפעלה</h2>
      <ul class="bnf-pending__list">
        @for (p of pending; track p.coupon_id) {
          <li class="bnf-pending__item">
            <div class="bnf-pending__main">
              <h3 class="bnf-card__title">{{ p.title }}</h3>
              <span class="bnf-chip bnf-chip--code">קוד: <span dir="ltr">{{ p.code }}</span></span>
              <ul class="bnf-pending__lines">
                @for (line of p.lines; track $index) { <li>{{ line }}</li> }
              </ul>
            </div>
            @if (p.can_activate && redemptionEnabled) {
              <button type="button" class="bnf-btn bnf-pending__btn" [disabled]="activatingId !== null"
                      (click)="activatePending(p)">
                {{ activatingId === p.coupon_id ? 'מפעילים...' : 'הפעלה' }}
              </button>
            } @else if (p.not_yet_active) {
              <span class="bnf-pending__soon">ייפתח להפעלה בקרוב</span>
            }
          </li>
        }
      </ul>
    </section>
  }

  <section class="bnf__list" aria-labelledby="bnf-list-title">
    <h2 id="bnf-list-title" class="bnf__h2">הקופונים שלי</h2>

    @if (state === 'loading' && !benefits) {
      <div class="bnf-skeleton" role="status" aria-live="polite">
        <span class="bnf-sr">טוען את ההטבות...</span>
        @for (i of [1, 2]; track i) {
          <div class="bnf-skeleton__card" aria-hidden="true">
            <span class="bnf-skeleton__line bnf-skeleton__line--w60"></span>
            <span class="bnf-skeleton__line bnf-skeleton__line--w40"></span>
            <span class="bnf-skeleton__line bnf-skeleton__line--w90"></span>
          </div>
        }
      </div>
    }

    @if (state === 'error' && !benefits) {
      <div class="bnf-state bnf-state--error" role="alert">
        <p>לא הצלחנו לטעון את ההטבות שלך. בדקו את החיבור ונסו שוב.</p>
        <button type="button" class="bnf-btn" (click)="load()">נסה שוב</button>
      </div>
    }

    @if (benefits) {
      <div class="bnf-summary" role="status">
        <span class="bnf-summary__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zm0 2.4L16.6 8H14V5.4zM17 19H7V5h5v5h5v9zm-8-6h6v2H9v-2zm0 3h6v2H9v-2z"/></svg>
        </span>
        <p class="bnf-summary__text">
          סה"כ <strong>{{ availableAds }}</strong> מודעות זמינות לפרסום מקופונים
        </p>
        @if (availableAds > 0 && publishingEnabled) {
          <a class="bnf-summary__cta" routerLink="/publish">פרסום מודעה</a>
        }
      </div>

      @if (!items.length) {
        <div class="bnf-state">
          <p class="bnf-state__title">עדיין אין לך הטבות</p>
          <p>כשתפעיל קוד הטבה, הוא יופיע כאן עם מכסת המודעות שלו.</p>
        </div>
      } @else {
        <ul class="bnf-grid">
          @for (c of items; track trackById($index, c)) {
            <li class="bnf-card" [class.bnf-card--history]="isHistory(c)" [class.bnf-card--active]="isActive(c)">
              <div class="bnf-card__top">
                <div class="bnf-card__heading">
                  <h3 class="bnf-card__title">{{ c.title }}</h3>
                  @if (c.campaign) {
                    <span class="bnf-card__campaign">{{ c.campaign }}</span>
                  }
                </div>
                <span class="bnf-status {{ statusClass(c) }}">{{ c.status_title }}</span>
              </div>

              @if (c.description) {
                <p class="bnf-card__desc">{{ c.description }}</p>
              }

              <div class="bnf-card__chips">
                <span class="bnf-chip bnf-level {{ levelClass(c) }}">{{ c.ad_level_label }}</span>
                <span class="bnf-chip">{{ c.ad_duration_days }} ימי פרסום</span>
                <span class="bnf-chip bnf-chip--code">קוד: <span dir="ltr">{{ c.code }}</span></span>
              </div>

              <div class="bnf-usage">
                <div class="bnf-usage__nums">
                  <span>סה"כ <strong>{{ c.granted_quota }}</strong></span>
                  <span>נוצלו <strong>{{ c.used }}</strong></span>
                  <span>נותרו <strong>{{ c.remaining }}</strong></span>
                </div>
                <div class="bnf-progress" role="progressbar"
                     [attr.aria-valuenow]="progress(c)" aria-valuemin="0" aria-valuemax="100"
                     [attr.aria-label]="'נוצלו ' + c.used + ' מתוך ' + c.granted_quota + ' מודעות'">
                  <span class="bnf-progress__bar" [style.width.%]="progress(c)"></span>
                </div>
              </div>

              <dl class="bnf-dates">
                @if (displayDate(c.starts_at)) {
                  <div><dt>תחילת ההטבה</dt><dd dir="ltr">{{ displayDate(c.starts_at) }}</dd></div>
                }
                @if (c.expires_at_display) {
                  <div><dt>בתוקף עד</dt><dd dir="ltr">{{ c.expires_at_display }}</dd></div>
                }
              </dl>

              @if (!isActive(c) && c.status_message) {
                <p class="bnf-card__status-msg">{{ c.status_message }}</p>
              }
            </li>
          }
        </ul>
      }
    }
  </section>
</div>
